export default {
    view: "Mutass többet"
}